import { errorLevel } from 'constants/errors';
import { treatErrorAs } from 'api/errors';

// Finders
import {
  findAffiliateList,
  findJohnDeereFields,
  findJohnDeereWorkPlans,
} from 'affiliates/finders';
import { Store } from 'store/types/types';

export const requestAffiliateList = () => {
  return async (dispatch: () => void, getState: () => Store) => {
    return Promise.resolve().then(() => {
      return findAffiliateList({ dispatch, getState }).catch(
        // eslint-disable-next-line
        treatErrorAs({ severity: errorLevel.WARN } as any),
      );
    });
  };
};

export const requestJohnDeereFields = () => {
  return async (dispatch: () => void, getState: () => Store) => {
    try {
      return findJohnDeereFields({ dispatch, getState });
    } catch {
      // eslint-disable-next-line
      return treatErrorAs({ severity: errorLevel.WARN } as any);
    }
  };
};

export const requestJohnDeereWorkPlans = () => {
  return async (dispatch: () => void, getState: () => Store) => {
    return findJohnDeereWorkPlans({ dispatch, getState });
  };
};
